import { Visibility } from '@mui/icons-material'
import ClearSharpIcon from '@mui/icons-material/ClearSharp'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import { Box, Button, Typography } from '@mui/material'
import { bookingsAPI } from 'api/bookingsAPI'
import { jobsAPI } from 'api/jobsAPI'
import handleCancelJob from 'components/Bookings/Common/CancelJob'
import isJobCancelDisabled from 'components/Bookings/Common/IsCancellable'

import { useMutation, useQuery } from '@tanstack/react-query'
import { BookingDetailsProps } from '../BookingStatusPage'
import Header from './Header'
import JourneyDetails from './JourneyDetails'
import PassengerDetails from './PassengerDetails'
import { PANEL_ACTION_GAP, panelActionButtonSx } from './panelActionStyles'

const BookingDetails = ({
  selectedJob,
  setSelectedJob,
  setIsReallocateModalOpen,
  setIsAmendModalOpen,
}: BookingDetailsProps) => {
  const { data } = useQuery({
    queryKey: ['selectedJob', selectedJob?.id],
    queryFn: async () => jobsAPI.getJobById(selectedJob?.id),
    refetchInterval: 30000,
  })

  //Cancel Job
  const { mutateAsync: cancelJob } = useMutation({
    mutationFn: (jobReference: string) => {
      return bookingsAPI.cancelVehicle(jobReference)
    },
  })

  const cancelExistingVehicle = async (jobReference: any) => {
    return await cancelJob(jobReference).then((data) => {
      if (data?.status === 204) {
        // props.history.push('/admin/dashboard')
      }
    })
  }

  const handleClickOpenCancel = async (job: any) => {
    handleCancelJob({
      job: job,
      action: () => cancelExistingVehicle(job.jobReference),
    })
  }
  return (
    <Box
      component="div"
      sx={{
        width: '96%',
        fontSize: '14px',
        backgroundColor: '#F8F8F8',
        color: '#8E8E8E',
        display: 'flex',
        flexShrink: 1,
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: '20px',
        marginX: 'auto',
        marginBottom: '20px',
        borderRadius: '8px',
        boxShadow: '0px 10px 24px rgba(0, 0, 0, 0.18)',
        maxHeight: '100%',
        overflowY: 'auto',
      }}
    >
      {!selectedJob.vehicleDetails.isTrackable && (
        <Box
          component="div"
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px 25px',
            backgroundColor: '#5B5B5B',
          }}
        >
          <Typography variant="h6" color={'#FFFFFF'}>
            Journey tracking unavailable
          </Typography>
        </Box>
      )}
      <Header selectedJob={data?.data} setSelectedJob={setSelectedJob} />
      <PassengerDetails selectedJob={data?.data} />
      <JourneyDetails selectedJob={data?.data} />
      <Box
        component="hr"
        sx={{
          width: '80%',
          height: '2px',
          background:
            'linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(142,142,142,1) 15%, rgba(142,142,142,1) 50%, rgba(142,142,142,1) 85%, rgba(0,0,0,0) 100%);',
        }}
      />
      <Box
        sx={{
          width: '90%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: PANEL_ACTION_GAP,
        }}
      >
        <Button
          startIcon={<DirectionsCarIcon />}
          onClick={() =>
            setIsReallocateModalOpen && setIsReallocateModalOpen(true)
          }
          sx={[
            panelActionButtonSx,
            (theme) => ({
              flex: '1 1 0',
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
              '&:hover,&:focus': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main,
              },
            }),
          ]}
        >
          reallocate
        </Button>

        <Button
          startIcon={<Visibility />}
          onClick={() => {
            setSelectedJob && setSelectedJob(selectedJob)
            setIsAmendModalOpen && setIsAmendModalOpen(true)
          }}
          sx={[
            panelActionButtonSx,
            (theme) => ({
              flex: '1 1 0',
              backgroundColor: theme.palette.brand.main,
              color: theme.palette.common.white,
              '&:hover,&:focus': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main,
              },
            }),
          ]}
        >
          View Job
        </Button>

        <Button
          startIcon={<ClearSharpIcon />}
          onClick={() => handleClickOpenCancel(data?.data)}
          sx={[
            panelActionButtonSx,
            (theme) => ({
              flex: '1 1 0',
              backgroundColor:
                theme.components.cancelButton?.backgroundColor || '#ff0000',
              color: theme.palette.common.white,
              '&:hover,&:focus': {
                color: theme.palette.common.white,
                backgroundColor: '#ff0000',
              },
              '&:disabled': {
                backgroundColor:
                  theme.components.disabledCancelButton?.backgroundColor ||
                  '#dc6666ff',
                color: theme.components.disabledCancelButton?.color || '#ccc',
              },
            }),
          ]}
          disabled={isJobCancelDisabled(data?.data.status.progress)}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  )
}

export default BookingDetails
